var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgressWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#in-progress--warning_svg__clip0_61530_7350)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.535 21h-5.072L18 15.927 20.535 21zM18 13.5a.75.75 0 00-.671.415l-3.75 7.5a.75.75 0 00.671 1.085h7.5a.75.75 0 00.691-1.042l-3.77-7.543A.75.75 0 0018 13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.06 17.1A7.5 7.5 0 1110.5 3v7.5l4.573 4.573.915-1.83A2.238 2.238 0 0118 12h1.364a8.994 8.994 0 10-8.864 7.5c.862 0 1.72-.126 2.545-.372L14.06 17.1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "in-progress--warning_svg__clip0_61530_7350"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgInProgressWarning;